import { Modal } from '../NewModal';
import useBreakpoint from '@/hooks/useBreakpoint';
import { RideBottomSheet, RideButton } from "@rimac-seguros/ride-system-components";
import DynamicIcon from '@/components/atoms/DynamicIcon/index';
import React from 'react';

import './styles.scss';

const ContentModal = ({
  onClose,
  title,
  message,
  icon,
  buttonText,
  callBackAction
}) => {
  const isDesktop = useBreakpoint('large-min');

  const handleClickButton = () => {
    callBackAction && callBackAction();
    onClose();
  };

  return (
    <div className="flex flex-col items-center gap-ride-gl-spacing-5xlarge lg:gap-ride-gl-spacing-2xlarge p-ride-gl-spacing-medium pb-ride-gl-spacing-2xlarge lg:p-ride-gl-spacing-9xlarge">
        <DynamicIcon icon={icon} size={isDesktop ? 'x-large' : 'small'} />
      <div className="flex flex-col gap-ride-gl-spacing-large lg:gap-ride-gl-spacing-xlarge">
        <h4 className="text-center ride-sys-text-title-3xlarge-default lg:ride-sys-text-title-3xlarge-default">
          {title}
        </h4>
        <p className="text-center ride-sys-text-paragraph-large-regular-short lg:ride-sys-text-paragraph-large-default">
          {message}
        </p>
      </div>
      <RideButton
        text={buttonText}
        size={isDesktop ? 'x-large' : 'large'}
        className="w-full modal-error-button lg:mt-ride-gl-spacing-2xlarge"
        onClick={handleClickButton}
      />
    </div>
  );
};

export const ModalError = ({ open, onClose, ref, ...props }) => {
  const isDesktop = useBreakpoint('large-min');

  return (
    <div className='modal-error'>
      <RideBottomSheet
        isOpen={open && !isDesktop}
        onOpenChange={(e) => {
          if (!e) {
            onClose();
          }
        }}
        className="modal-error-mobile"
      >
        <ContentModal
          onClose={onClose}
          {...props}
        />
      </RideBottomSheet>
      <Modal
        isOpen={open && isDesktop}
        iconClose
        onClose={onClose}
        ref={ref}
        className="col-span-6 col-start-4 bg-ride-sys-color-background-default rounded-3xl"
      >
        <ContentModal onClose={onClose} {...props} />
      </Modal>
    </div>
  );
};